<script lang="ts" setup>
import { computed, watch, useIntercom, useCookiebotConsent } from '#imports'

const { boot, hasConsent, showCookieNotice, isUnavailableNoticeVisible, isBooted, isIntercomEnabled } = useIntercom()
const { isConsentReady } = useCookiebotConsent()

const showIntercomIcon = computed(() => {
    if (!isIntercomEnabled.value) return false
    if (!isConsentReady.value) return false

    return !hasConsent.value
})

const shouldShowIntercom = computed(() => isIntercomEnabled.value && isConsentReady.value && hasConsent.value)

if (import.meta.client) {
    watch(shouldShowIntercom, async (isActive) => {
        if (isActive) {
            if (!isBooted.value) {
                await boot()
            }

            return
        }

        if (isBooted.value) {
            const { shutdown } = await import('@intercom/messenger-js-sdk')
            shutdown()
        }
        isBooted.value = false
    }, { immediate: true })
}
</script>

<template>
    <ClientOnly>
        <LazyUIIntercomChatIcon v-if="showIntercomIcon" />
        <LazyUICookieNotice v-if="showCookieNotice" />
        <LazyUIIntercomUnavailableNotice v-if="isUnavailableNoticeVisible" />
    </ClientOnly>
</template>
